import { Box } from '@mui/material';
import { Camera } from 'components/Camera/Camera';
import Page from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { useLanguage } from 'context/AppContext';

type Props = {
  setName: string;
  trayName: string;
  onBackClick: () => void;
  onImageCapture: (imageDataUri: string) => void;
};

export const TrayImageCapture = ({ setName, trayName, onBackClick, onImageCapture }: Props) => {
  const lang = useLanguage()[0].TrayImageCapture;

  return (
    <Page>
      <PageHeader title={`${lang.title}: ${setName}: ${trayName}`} onBackClick={onBackClick} />
      <Box className="page-content">
        <Camera updateCapturedImage={onImageCapture} />
      </Box>
    </Page>
  );
};
